import { render, staticRenderFns } from "./SwitchesGroup-gt3.vue?vue&type=template&id=37b87e90&scoped=true"
import script from "./SwitchesGroup-gt3.vue?vue&type=script&lang=js"
export * from "./SwitchesGroup-gt3.vue?vue&type=script&lang=js"
import style0 from "./SwitchesGroup-gt3.vue?vue&type=style&index=0&id=37b87e90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b87e90",
  null
  
)

export default component.exports